import c from "./consts";

export default {
  [c.IS_LOADING]: false,
  [c.CURRENT_USER]: null,
  [c.AUTH_INITIALIZED]: false,
};